import { renderField, renderAnyHitDetails } from "./SignalCheckDataReviewUtils";

const isSuspectArticleValue = (value) =>
  value !== null && typeof value === "object" && !Array.isArray(value);

const GenericArticleHitDetails = (item, index, array) => {
  const value = item?.value;

  if (!isSuspectArticleValue(value)) {
    return renderAnyHitDetails(item, index, array);
  }

  return (
    <div key={index}>
      {renderField("Title", value.title)}
      {value.matched_by?.length > 0 && (
          <>
            <p><strong>Matched by:</strong></p>
            <ul>{value.matched_by.map((h, i) => <li key={i}>{h}</li>)}</ul>
          </>
      )}
      {value.original_hits?.length > 0 && (
        <>
          <p><strong>Original hits:</strong></p>
          <ul>{value.original_hits.map((h, i) => <li key={i}>{h}</li>)}</ul>
        </>
      )}
      {renderField("Provided by", item?.providedby)}
      {renderField("Timestamp", item?.timestamp)}
      {renderField("Comment", item?.comment)}
      {index < array.length - 1 && <hr className="hr" />}
    </div>
  );
};

export default GenericArticleHitDetails;
